import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import _noop from 'lodash/noop';

import {
  Icons,
  RadioGroupInput,
  MaskedInput as Input,
} from '@casanova/casanova-common';
import { ActionModal } from '@casanova/casanova-common/lib/Modal';

import i18n from '@i18n';
import { FormModal } from 'components';
import { numericMask, alphaEmailMask } from 'utils/masks';
import { AREA_OPTIONS } from '@reservations/commons/constants';
import { useSelector } from 'react-redux';

const OPTIONS = [
  {
    label: 'Celular',
    value: AREA_OPTIONS.CELLPHONE,
  },
  {
    label: 'Correo electrónico',
    value: AREA_OPTIONS.EMAIL,
  },
];

export default function SendReservationModal({
  onActionSuccess = _noop,
  onCancel = _noop,
  onAreaChange = _noop,
  onCancelModifyData = _noop,
  onClickSubDescription = _noop,
  show = false,
  showSuccess = false,
  showModifyData = false,
  onSubmit,
  area = AREA_OPTIONS.USER,
  // strictValidation = true,
  onlySubmit = false,
}) {
  const folio =
    useSelector((state) => state.reservations.reservation.folio) || 'Sin folio';

  const handleCancelFirm = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleActionFirm = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  const handleClickSubDescription = useCallback(() => {
    onClickSubDescription();
  }, [onClickSubDescription]);

  const handleCancelModifyData = useCallback(() => {
    onCancelModifyData();
  }, [onCancelModifyData]);

  const handleSubmitModifyData = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  const handleActionSuccess = useCallback(() => {
    onActionSuccess();
  }, [onActionSuccess]);

  const handleAreaChange = useCallback(
    (areaValues) => {
      onAreaChange(areaValues);
    },
    [onAreaChange]
  );

  return (
    <>
      <ActionModal
        open={show}
        closeLabel={i18n('COMMONS__CANCEL__TEXT')}
        actionLabel={i18n('COMMONS__YES_CONTINUE__TEXT')}
        title={i18n('RESERVATIONS__CREATE__RESERVATION__DIALOG__TITLE')}
        message={i18n('RESERVATIONS__CREATE__RESERVATION__DIALOG__TEXT', [
          folio,
        ])}
        icon={<Icons.IcoCarOk />}
        messageBold
        textBold={[`${folio}`]}
        subDescription="Modificar los datos de envío"
        onClickSubDescription={handleClickSubDescription}
        onClose={handleCancelFirm}
        onAction={handleActionFirm}
        onlySubmit={onlySubmit}
      />
      <ActionModal
        open={showSuccess}
        closeLabel={i18n('COMMONS__NO_RESEND__TEXT')}
        actionLabel={i18n('COMMONS__YES_CONTINUE__TEXT')}
        title={i18n(
          'RESERVATIONS__CONTRACT__PROMISSORY_NOTE__MODAL__SUCCESS__TITLE'
        )}
        message={i18n(
          'RESERVATIONS__CONTRACT__PROMISSORY_NOTE__MODAL__SUCCESS__DESCRIPTION'
        )}
        icon={<Icons.IcoCarOk />}
        subDescription="Modificar los datos de envío"
        onClickSubDescription={handleClickSubDescription}
        onClose={handleActionFirm}
        onAction={handleActionSuccess}
      />
      <FormModal
        open={showModifyData}
        title={i18n(
          'RESERVATIONS__CONTRACT__PROMISSORY_NOTE__MODAL__MODIFY_DATA__TITLE'
        )}
        description={i18n(
          'RESERVATIONS__CREATE__RESERVATION__MODIFY_DATA__DESCRIPTION'
        )}
        submitLabel={i18n('COMMONS__SEND__TEXT')}
        onCancel={handleCancelModifyData}
        onSubmit={handleSubmitModifyData}
      >
        <div className="row">
          <div className="col-12">
            <RadioGroupInput
              labelClass="d-flex align-items-center"
              groupClass="col-12 d-flex justify-content-around"
              parentClass="vehicle-radio-input"
              label=""
              name="area"
              value={area}
              options={OPTIONS}
              standardError
              onChange={handleAreaChange}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Input
              name={area}
              placeholder={i18n('COMMONS__PLACEHOLDER__WRITE')}
              maskPlaceholder=""
              mask={
                area === AREA_OPTIONS.EMAIL
                  ? alphaEmailMask(50)
                  : numericMask(10)
              }
            />
          </div>
        </div>
      </FormModal>
    </>
  );
}

SendReservationModal.propTypes = {
  onActionSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  onAreaChange: PropTypes.func,
  onCancelModifyData: PropTypes.func,
  onClickSubDescription: PropTypes.func,
  show: PropTypes.bool.isRequired,
  showSuccess: PropTypes.bool,
  showModifyData: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  area: PropTypes.string,
  strictValidation: PropTypes.bool,
  onlySubmit: PropTypes.bool,
};
